export const CompareObjects = (Objects1:any, Objects2:any) : boolean => {
    return JSON.stringify(Objects1) === JSON.stringify(Objects2) ? false : true;
}